<template>
    <div>
        <el-form :model="landSearchFilter" ref="projectForm" :rules="rules" label-position="left" class="employer-ruleForm">
        <el-row>
            <el-col :span="12">
                <el-form-item label="投资日期" prop="startDate" :label-width="labelWidth">
                    <el-date-picker size="large" v-model="landSearchFilter.startDate" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.endDate" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="约定支付时间" prop="paymentDate" :label-width="labelWidth">
                    <el-date-picker v-model="landSearchFilter.paymentStartDate" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.paymentEndDate" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="约定交地时间" prop="landDeliveryStartDate" :label-width="labelWidth">
                    <el-date-picker v-model="landSearchFilter.landDeliveryStartDate" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.landDeliveryEndDate" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="约定开工时间" prop="commencementStartDate" :label-width="labelWidth">
                    <el-date-picker v-model="landSearchFilter.commencementStartDate" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.commencementEndDate" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="行政区域" prop="area" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.province" placeholder="请选择">
                        <el-option v-for="(item, index) in provinceList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.city" placeholder="请选择">
                        <el-option v-for="(item, index) in cityList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.county" placeholder="请选择">
                        <el-option v-for="(item, index) in countyList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="投资来源地" prop="parentProvince" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.parentProvince" placeholder="请选择">
                        <el-option v-for="(item, index) in provinceList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.parentCity" placeholder="请选择">
                        <el-option v-for="(item, index) in cityList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.parentCounty" placeholder="请选择">
                        <el-option v-for="(item, index) in countyList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="行业分类" prop="notionCode1" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode1" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList1" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode2" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList2" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode3" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList3" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="土地性质" prop="bigLandUseList" :label-width="labelWidth">
                    <el-select  v-model="landSearchFilter.bigLandUse" placeholder="请选择">
                        <el-option v-for="(item, index) in bigLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="landSearchFilter.smallLandUse" placeholder="请选择">
                        <el-option v-for="(item, index) in smallLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="总面积" prop="minSize" :label-width="labelWidth">
                    <el-input class="num-size-input" v-model="landSearchFilter.minSize" placeholder=""></el-input>
                    -
                    <el-input class="num-size-input" v-model="landSearchFilter.maxSize" placeholder=""></el-input>
                    （亩）
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="成交价格" prop="minPrice" :label-width="labelWidth">
                    <el-input class="num-size-input" v-model="landSearchFilter.minPrice" placeholder=""></el-input>
                    -
                    <el-input class="num-size-input" v-model="landSearchFilter.maxPrice" placeholder=""></el-input>
                    （万元）
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="容积率" prop="floorAreaRatio" :label-width="labelWidth">
                    <el-input class="num-size-input" v-model="landSearchFilter.minFloorAreaRatio" placeholder=""></el-input>
                    -
                    <el-input class="num-size-input" v-model="landSearchFilter.maxFloorAreaRatio" placeholder=""></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="使用年限" prop="useYears" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.useYears" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="供地方式" prop="bigSupplyMode" :label-width="labelWidth">
                    <el-select  v-model="landSearchFilter.bigSupplyMode" placeholder="请选择">
                        <el-option v-for="(item, index) in bigLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="landSearchFilter.smallSupplyMode" placeholder="请选择">
                        <el-option v-for="(item, index) in smallLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="土地级别" prop="landLevel" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.landLevel" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="项目名称" prop="projectName" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.projectName" placeholder=""></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="项目位置" prop="projectLocation" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.projectLocation" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="使用权人" prop="landOwner" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.landOwner" placeholder=""></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="投资主体" prop="parentKW" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.parentKW" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <div class="btn oh mr-8 mb-2">
        <div class="fr">
             <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'landFilterCom',
    data() {
        return {
            labelWidth: '120px',
            rules: {},
            landSearchFilter: {
                province: '',
                city: '',
                county: '',
                parentProvince: '',
                parentCity: '',
                parentCounty: '',
                notionCode1: '',
                notionCode2: '',
                notionCode3: '',
                bigLandUse: '',
                smallLandUse: '',
                minPrice: '',
                maxPrice: '',
                minFloorAreaRatio: '',
                maxFloorAreaRatio: '',  
                useYears: '',
                landLevel: '',
                projectName: '',
                projectLocation: '',
                landOwner: '', 
                parentKW: '',
                bigSupplyMode: '',
                smallSupplyMode: '',
                
            },
            provinceList: [
                { value: '1', label: '北京' },
                { value: '2', label: '天津' },
                { value: '3', label: '河北' },
                { value: '4', label: '山西' },
                { value: '5', label: '内蒙古' },
                { value: '6', label: '辽宁' },
                { value: '7', label: '吉林' },
            ],
            cityList: [
                { value: '1', label: '保定' },
                { value: '2', label: '北京' },
                { value: '3', label: '石家庄' },
            ],
            countyList: [
                { value: '1', label: '东城区' },
                { value: '2', label: '西城区' },
                { value: '3', label: '海淀区' },
                { value: '4', label: '朝阳区' },
                { value: '5', label: '丰台区' },
                { value: '6', label: '石景山区' },
            ],
            bigLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            smallLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            notionList1: [{ value: '1', label: '机器人' }],
            notionList2:[{ value: '1', label: '制造业' }],
            notionList3: [{ value: '1', label: '机器人制造' },]
        }
    },
    created() { 
    },
    mounted() { 
    },
    methods: {
        search() {
            this.$emit('search', this.landSearchFilter)
        },
        reset() {
            this.landSearchFilter = {
                province: '',
                city: '',
                county: '',
                parentProvince: '',
                parentCity: '',
                parentCounty: '',
                notionCode1: '',
                notionCode2: '',
            }
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .text-input{
        width: 70%
    }
    .el-input__inner{
        font-size: 14px;
        // line-height: 80px;
        height: 38px;
    }
    .el-form-item__label{
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }
    .num-size-input{
        width: 180px;
    }
    .seletc-size-input{
        width: 140px;
    }
}
</style>